"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineReelConfig = void 0;
/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
const GameConfig_1 = require("../../core/gameconfig/GameConfig");
class TimelineReelConfig {
    constructor(reelId) {
        this._reelId = reelId;
        this.startDuration = this.getConfig(GameConfig_1.GameConfig.instance.REEL_SPIN_START_SPEED);
        this.stepDuration = this.getConfig(GameConfig_1.GameConfig.instance.REEL_SPIN_SPIN_SPEED);
        this.nearWinStepDuration = this.getConfig(GameConfig_1.GameConfig.instance.REEL_NEAR_WIN_SPIN_SPEED);
        this.stopDuration = this.getConfig(GameConfig_1.GameConfig.instance.REEL_SPIN_STOP_SPEED);
        this.quickStopDuration = this.getConfig(GameConfig_1.GameConfig.instance.REEL_SPIN_QUICK_STOP_SPEED);
        this.stopDelay = this.getConfig(GameConfig_1.GameConfig.instance.REEL_STOP_DELAY);
        this.quickStopDelay = this.getConfig(GameConfig_1.GameConfig.instance.REEL_QUICK_STOP_DELAY);
        this.nearWinDuration = this.getConfig(GameConfig_1.GameConfig.instance.REEL_NEAR_WIN_STOP_DELAY);
    }
    getConfig(configValue) {
        let value;
        if (typeof configValue == "number") {
            value = configValue;
        }
        else {
            value = configValue[this._reelId];
        }
        return value;
    }
}
exports.TimelineReelConfig = TimelineReelConfig;
//# sourceMappingURL=TimelineReelConfig.js.map